// Central helpers for dealing with tours incorrectly associated to generic artist records

export const GENERIC_ARTIST_NAMES = [
  'live',
  'fest',
  'festival',
  'tour',
  'concert',
  'show',
  'music',
  'band',
  'dj',
  'world',
] as const;

export function isGenericArtistName(name?: string | null): boolean {
  const n = (name || '').trim().toLowerCase();
  if (!n) return false;
  return (GENERIC_ARTIST_NAMES as readonly string[]).includes(n);
}

/**
 * Extract a likely headliner artist name from a tour title.
 * Examples:
 * - "Eagles Live at Sphere" -> "Eagles"
 * - "BrownstoneJAZZ FEST CONCERT SERIES" -> "BrownstoneJAZZ"
 */
export function extractArtistFromTourName(tourName: string): string {
  if (!tourName) return '';

  const extracted = tourName
    // Live patterns
    .replace(/\s*[-:]\s*LIVE!?\s*$/i, '')
    .replace(/\s+LIVE!?\s*$/i, '')
    .replace(/\s+Live!?\s*$/i, '')
    .replace(/\s+LIVE\s+at\s+.+$/i, '')
    .replace(/\s+Live\s+at\s+.+$/i, '')

    // Fest patterns
    .replace(/\s+FEST\s*$/i, '')
    .replace(/\s+Fest\s*$/i, '')
    .replace(/\s+FESTIVAL\s*$/i, '')
    .replace(/\s+Festival\s*$/i, '')

    // Other suffixes
    .replace(/\s+TOUR\s*$/i, '')
    .replace(/\s+Tour\s*$/i, '')
    .replace(/\s+CONCERT\s+SERIES\s*$/i, '')
    .replace(/\s+Concert\s+Series\s*$/i, '')
    .trim();

  return extracted !== tourName ? extracted : '';
}
